const normalizeNumericInput = (raw: string) => raw.replace(/\s/g, '').replace(/[^\d,.-]/g, '');

export const parseCentsFromInput = (raw: string): number | null => {
  const value = normalizeNumericInput(raw);
  if (!value) return null;

  const lastDot = value.lastIndexOf('.');
  const lastComma = value.lastIndexOf(',');
  const decimalIndex = Math.max(lastDot, lastComma);

  const integerPart = decimalIndex >= 0 ? value.slice(0, decimalIndex) : value;
  const fractionPart = decimalIndex >= 0 ? value.slice(decimalIndex + 1) : '';

  const normalizedInteger = integerPart.replace(/[.,]/g, '');
  const normalizedFraction = fractionPart.replace(/[.,]/g, '').slice(0, 2).padEnd(2, '0');
  const sign = normalizedInteger.trim().startsWith('-') ? -1 : 1;

  const digits = normalizedInteger.replace(/[^0-9]/g, '');
  if (!digits && !normalizedFraction) return null;

  const cents =
    (Number.parseInt(digits || '0', 10) * 100 + Number.parseInt(normalizedFraction || '0', 10)) *
    sign;
  return Number.isFinite(cents) ? cents : null;
};

export const formatCurrencyFromCents = (cents: number, locale: string) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);

export const formatCentsToInput = (cents: number, locale: string) =>
  new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    (cents || 0) / 100
  );
